<template>
  <div
    class="SidebarLinks"
    :class="{
      'SidebarLinks--auto-flow': this.isAutoFlowUser,
    }"
  >
    <template v-if="$route.path.indexOf('/onboarding') !== -1"></template>

    <template v-else-if="authenticated">
      <language-switcher />
      <sidebar-link
        to="dashboard"
        :text="$t('appSidebar.sidebarLinks.dashboard')"
      >
        <house-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="!isVolunteer"
        to="sessions/history"
        :text="$t('appSidebar.sidebarLinks.sessionHistory')"
      >
        <archive-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="!isVolunteer"
        to="favorite-coaches"
        :text="$t('appSidebar.sidebarLinks.favoriteCoaches')"
      >
        <heart-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="isVolunteer"
        to="training"
        :text="$t('appSidebar.sidebarLinks.training')"
      >
        <graduation-cap-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="isVolunteer"
        to="calendar"
        :text="$t('appSidebar.sidebarLinks.schedule')"
      >
        <calendar-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="isVolunteer && isTutorSessionHistoryActive"
        to="sessions/history"
        :text="$t('appSidebar.sidebarLinks.sessionHistory')"
      >
        <archive-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="isAdmin"
        to="admin"
        :text="$t('appSidebar.sidebarLinks.admin')"
      >
        <folder-icon class="icon" />
      </sidebar-link>

      <sidebar-link to="profile" :text="$t('appSidebar.sidebarLinks.profile')">
        <portrait-icon class="icon" />
      </sidebar-link>

      <sidebar-link
        v-if="showDashboardRedesign"
        :text="$t('appSidebar.sidebarLinks.referFriend')"
        :onClick="openReferFriendModal"
      >
        <refer-friend-icon class="icon" />
      </sidebar-link>

      <div v-if="!mobileMode" class="SidebarLinks-about">
        {{ $t('appSidebar.sidebarLinks.aboutBorna') }}
      </div>
      <sidebar-link
        to="contact"
        :text="$t('appSidebar.sidebarLinks.contactUs')"
      >
        <envelope-icon class="icon" />
      </sidebar-link>
      <sidebar-link
        to="legal"
        :text="$t('appSidebar.sidebarLinks.legalPolicy')"
        v-if="!isVolunteer"
      >
        <exclamation-icon class="icon" />
      </sidebar-link>
      <sidebar-link
        v-if="isVolunteer"
        to="https://chat.whatsapp.com/EI0pQosY9DHAmJD9c1RCI4"
        :text="$t('appSidebar.sidebarLinks.community')"
        :openNewTab="true"
      >
        <whatsapp-logo-icon class="icon-whatsapp-logo" />
      </sidebar-link>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarLink from './SidebarLink.vue'
import ArchiveIcon from '@/assets/archive.svg'
import CalendarIcon from '@/assets/sidebar_icons/calendar.svg'
import EnvelopeIcon from '@/assets/sidebar_icons/envelope.svg'
import ExclamationIcon from '@/assets/sidebar_icons/exclamation.svg'
import FolderIcon from '@/assets/sidebar_icons/folder.svg'
import GraduationCapIcon from '@/assets/sidebar_icons/graduation-cap.svg'
import HeartIcon from '@/assets/heart.svg'
import HouseIcon from '@/assets/sidebar_icons/house.svg'
import PortraitIcon from '@/assets/sidebar_icons/portrait.svg'
import ReferFriendIcon from '@/assets/sidebar_icons/refer-friend-icon.svg'
import ReferralSVG from '@/assets/dashboard_icons/student/referral.svg'
import WhatsappLogoIcon from '@/assets/whatsapp.svg'
import AnalyticsService from '@/services/AnalyticsService'
import { EVENTS } from '@/consts'
import LanguageSwitcher from './LanguageSwitcher.vue'

export default {
  components: {
    SidebarLink,
    ArchiveIcon,
    CalendarIcon,
    EnvelopeIcon,
    ExclamationIcon,
    FolderIcon,
    GraduationCapIcon,
    HeartIcon,
    HouseIcon,
    PortraitIcon,
    ReferFriendIcon,
    WhatsappLogoIcon,
    LanguageSwitcher,
  },
  props: {
    authenticated: Boolean,
    isVolunteer: Boolean,
    isAdmin: Boolean,
    mobileMode: Boolean,
  },
  computed: {
    ...mapGetters({
      isTutorSessionHistoryActive: 'featureFlags/isTutorSessionHistoryActive',
      isAutoFlowUser: 'user/isAutoFlowUser',
      showDashboardRedesign: 'user/showDashboardRedesign',
    }),
  },
  methods: {
    openReferFriendModal() {
      AnalyticsService.captureEvent(EVENTS.STUDENT_CLICKED_REFER_A_FRIEND)
      let header
      let subcopy
      if (this.referralCopy === 'baseline') {
        header = this.$root.$t(
          'appSidebar.sidebarLinks.referral.baseline.header'
        )
        subcopy = this.$root.$t(
          'appSidebar.sidebarLinks.referral.baseline.subCopy'
        )
      } else if (this.referralCopy === 'small-gift-card') {
        header = this.$root.$t(
          'appSidebar.sidebarLinks.referral.smallGiftCard.header'
        )
        subcopy = this.$root.$t(
          'appSidebar.sidebarLinks.referral.smallGiftCard.subCopy'
        )
      } else if (this.referralCopy === 'emotional-appeal-struggling') {
        header = this.$root.$t(
          'appSidebar.sidebarLinks.referral.emotionalAppealStruggling.header'
        )
        subcopy = this.$root.$t(
          'appSidebar.sidebarLinks.referral.emotionalAppealStruggling.subCopy'
        )
      }
      this.$store.dispatch('app/modal/show', {
        component: 'ReferralModal',
        data: {
          svg: ReferralSVG,
          showAccept: false,
          header,
          subcopy,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.SidebarLinks {
  @include flex-container(column);
  @include child-spacing(top, 16px);

  &-about {
    @include font-category('body');
    color: $c-secondary-grey;
    margin-top: 40px;
    text-align: left;
  }

  &--auto-flow {
    visibility: hidden;
  }
}

.icon {
  margin-right: 0.8em;
  width: 24px;
}

.icon-whatsapp-logo {
  margin-right: 0.8em;
  width: 20px;
  height: 20px;
}

html.is-rtl {
  .icon {
    margin-left: 0.8em;
    margin-right: unset;
  }

  .icon-whatsapp-logo {
    margin-left: 0.8em;
    margin-right: unset;
  }

  .SidebarLinks {
    &-about {
      text-align: right;
    }
  }
}
</style>
